module.exports = __webpack_public_path__ + "static/media/article1.646b78c0.jpeg";